﻿import ApiService from "services/ApiService";
import ApiRequestService from "services/ApiRequestService";
const badRequestCode = 400;

export const EmployeeService = {
    getPolicy(policyId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/Policies/${policyId}`).then(
                (result) => {
                    const policy = result.data;
                    policy.locations = policy.locationIds.map(
                        (location, index) => {
                            return {
                                id: location.id,
                                name: policy.locationNames[index],
                            };
                        }
                    );

                    resolve(policy);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getPolicies(resultCount, currentPageNumber, sortField, sortDir) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/Policies?resultCount=${resultCount}&currentPageNumber=${currentPageNumber}&sortField=${encodeURI(
                    sortField
                )}&sortDirection=${sortDir}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getEmployeeOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/Options/Employee`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getPolicyDocuments() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/PolicyDocuments`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    savePolicy(policy) {
        policy.locationIds = policy.locations;

        return new Promise((resolve, reject) => {
            ApiService.put(`/employee/Policies/${policy.policyId}`, policy)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    updatePolicyDataRetentions(dataRetentions) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/employee/Policies/DataRetention`, dataRetentions)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },

    uploadPolicyDocument(document, documentId) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("file", document.file);

        formData.append("isGenericDocument", document.isGenericDocument);

        return new Promise((resolve, reject) => {
            ApiService.put(
                `/employee/PolicyDocuments/${documentId}`,
                formData,
                config
            )
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    createPolicyDocument(document) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("file", document.file);

        formData.append("isGenericDocument", document.isGenericDocument);

        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/PolicyDocuments`, formData, config)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    createPolicy(policy) {
        policy.locationIds = policy.locations;

        return new Promise((resolve, reject) => {
            ApiService.post("/employee/Policies", policy)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getChangelog(policyId, pageSize, pageNumber, startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/changelog/${policyId}?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getEmployeeAssessmentSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get("/employee/employeeAssessmentSettings").then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveEmployeeAssessmentSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/employeeAssessmentSettings", settings)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getEmployeeSettingsChangelog(pageSize, pageNumber, startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/changelog/employeeSettings?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getEmployeeAssessmentSettingsOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get("/employee/options/employeeAssessmentSettings").then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getTrainingSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get("/employee/dcpcSettings").then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveTrainingSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/dcpcSettings", settings).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getEmployeeList(
        pageSize,
        pageNumber,
        searchTerm,
        sortField,
        sortDir,
        filters
    ) {
        var filterQuery = "";

        filters.forEach(function (element, index) {
            filterQuery += `filters[${index}].Key=${encodeURIComponent(
                element.name
            )}&filters[${index}].Value=${encodeURIComponent(element.value)}&`;
        });

        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/Employees?requestCount=${pageSize}&pageNumber=${pageNumber}&searchTerm=${encodeURIComponent(
                    searchTerm
                )}&sortField=${encodeURI(
                    sortField
                )}&sortDirection=${sortDir}&${filterQuery}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    internalSearchEmployees(pageSize, pageNumber, searchTerm) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/Search?requestCount=${pageSize}&pageNumber=${pageNumber}&searchTerm=${searchTerm}`
            )
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function () {
                    reject("Unable to search employees. Please try again.");
                });
        });
    },
    searchEmployees(data) {
        return new Promise((resolve, reject) => {
            ApiService.post("/employee/Employees/Search", data).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    bulkMoveEmployeesForLocation(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/employee/BulkMove/Location`, settings)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    bulkMoveEmployeesForAccount(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/employee/BulkMove/Account`, settings)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getBulkMoveChangeLogForLocation(
        locationId,
        pageSize,
        pageNumber,
        startDate,
        endDate
    ) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/BulkMove/Location/Changelog/${locationId}?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getEmployee(employeeId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/Employees/${employeeId}`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    },
    updateEmployee(employeeId, employee) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/employee/Employees/${employeeId}`, employee)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    },
    getMedicalInformation(employeeId) {
        return ApiRequestService.get("employee", `Employees/${employeeId}/MedicalInformation`);
    },
    saveMedicalInformation(employeeId, medicalInformation) {
        return ApiRequestService.put("employee", `Employees/${employeeId}/MedicalInformation`, medicalInformation);
    },
    crackDriverCard(driverCard) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("file", driverCard);

        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/DriverCards/Contents`, formData, config)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    uploadDriverCardFile(file, locationId) {
        // The driver card is uploaded through the legacy endpoint so it goes through the
        // old system processes. The legacy endpoint takes the file as base64 CardData in a
        // JSON body rather than as multipart form data.
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = function () {
                // readAsDataURL produces "data:<mime>;base64,<data>" — the endpoint wants
                // just the base64 portion.
                const cardData = reader.result.split(",")[1];

                ApiService.post(`/employee/DriverCards`, {
                    cardData: cardData,
                    externalFilename: file.name,
                    microserviceLocationId: locationId,
                    // Identifies the upload source so the legacy system records it as an
                    // import-page upload rather than a Vision Uploader one.
                    source: "ImportPage"
                })
                    .then(function (response) {
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        if (error.response && error.response.status === badRequestCode) {
                            reject(error.response.data);
                        } else {
                            reject("Unable to upload the driver card file, please try again.");
                        }
                    });
            };

            reader.onerror = function () {
                reject("Unable to read the driver card file, please try again.");
            };

            reader.readAsDataURL(file);
        });
    },
    GetHoldingAreaCounts() {
        return ApiRequestService.get("employee", "holdingArea");
    },
    uploadPrintout(formFile, printoutForDate, employeeId) {
        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("formFile", formFile);
        formData.append("printoutForDate", printoutForDate);
        formData.append("employeeId", employeeId);

        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/Printouts/`, formData, config)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    postAwaitingData(employeeId, date, type) {
        let payload = {
            employeeId: employeeId,
            date: date,
            type: {
                id: type,
            },
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/AwaitingData/`, payload)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getDebriefSignOff(debriefId, code) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/Debriefs/Signoff?debriefId=${debriefId}&token=${code}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveDebriefSignOff(id, code, signature) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/employee/Debriefs/${id}/Signoff/Email`, {
                token: code,
                signature: signature,
            })
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getPolicySignOffActionsForAccount(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/policysignoffactions/search`,
                searchObject)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search policy sign-off actions. Please try again later."
                            );
                        }
                    }
                );
        });
    },
    getPolicySignOffActionsForEmployee(searchObject) {
        const { employeeId, ...searchParams } = searchObject;

        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/policysignoffactions/employee/${employeeId}/search`,
                searchParams)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response);
                        } else {
                            reject(
                                "Unable to search policy sign-off actions. Please try again later."
                            );
                        }
                    }
                );
        });
    },
    downloadUnsignedPolicyDocument(documentStorageIdentifier) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/policydocuments/downloadunsignedpolicydocument/${documentStorageIdentifier}`, { responseType: "blob" }).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response);
                    } else {
                        reject(
                            "Unable to download unsigned policy document. Please try again later."
                        );
                    }
                }
            );
        });
    },
    downloadSignedPolicyDocument(documentStorageIdentifier) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/policydocuments/downloadSignedpolicydocument/${documentStorageIdentifier}`, { responseType: "blob" }).then(
                (response) => {
                    resolve(response.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response);
                    } else {
                        reject(
                            "Unable to download signed policy document. Please try again later."
                        );
                    }
                }
            );
        });
    },    
    signoffPolicyDocument(policyId, documentId, employeeId, signature) {
        const formData = new FormData();
        formData.append("policyId", policyId);
        formData.append("documentId", documentId);
        formData.append("employeeId", employeeId);
        formData.append("signature", signature, "signature.png");

        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/policydocumentviews/`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};